module.exports = __webpack_public_path__ + "static/media/49.07e8eb19.png";